<template>
  <div class="txt-img-section">
    <div class="txt-wrap">
      <p class="txt-desc fade-up" v-html="txtImgObj.desc"></p>
      <p class="txt-title fade-up" v-html="txtImgObj.title"></p>
    </div>
    <img v-if="isMobile" class="img-cover" :src="txtImgObj.mobileImg" :alt="txtImgObj.title" />
    <template v-else>
      <img class="img-cover" v-for="img in txtImgObj.imgList" :key="img" :src="img" :alt="txtImgObj.title" />
    </template>
  </div>
</template>

<script>
import { fadeAnimate, destroyFadeAnimate } from '../utils/animation.js'
export default {
  name: 'CarUpTxtDownImg',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    txtImgObj: {
      type: Object,
      required: true
    },
  },
  mounted() {
    fadeAnimate();
  },
  beforeDestroy() {
    destroyFadeAnimate();
  },
  data() {
    return {

    }
  },
}
</script>

<style lang="less" scoped>
.txt-img-section {
  width: 100%;
  .txt-wrap {
    padding: 3.43vw 0;
    background-color: #030303;
    display: flex;
    flex-direction: column;
    justify-content: center;
    .txt-desc {
      margin: 0 auto;
      width: 55vw;
      text-align: center;
      font-size: clamp(16px, 1.25vw, 24px);
      font-weight: @fw2;
      line-height: 1.6;
      color: rgba(255, 255, 255, 0.7);
    }
    .txt-title {
      margin: 16px auto 0;
      width: 71vw;
      text-align: center;
      font-size: clamp(38px, 2.5vw, 48px);
      font-weight: @fw1;
      line-height: 1.4;
      color: #ffffff;
    }
  }
}
@media (max-width: @mobile-width) {
  .txt-img-section {
    position: relative;
    .txt-wrap {
      position: absolute;
      padding: 0 5.33vw;
      inset: 0;
      background-color: transparent;
      justify-content: start;
      .txt-desc {
        width: 100%;
        font-size: 4.26vw;
        margin-top: 16vw;
        color: #ffffff;
      }
      .txt-title {
        width: 100%;
        font-size: 8.53vw;
        line-height: 1.2;
      }
    }
  }
}
</style>